import {
  SET_LOADING_TRUE,
  SET_LOADING_FALSE,
  GET_GOALS_IN_PROGRESS,
  GET_GOALS_SUCCESS,
  GET_GOALS_FAILED,
  UPDATE_GOALS_IN_PROGRESS,
  UPDATE_GOALS_SUCCESS,
  UPDATE_GOALS_FAILED,
  ARCHIVE_GOALS_IN_PROGRESS,
  ARCHIVE_GOALS_SUCCESS,
  ARCHIVE_GOALS_FAILED,
  REFRESH_GOALS,
  LOG_USER_OUT,
  NEW_GOALS_IN_PROGRESS,
  NEW_GOALS_FAILED,
  NEW_GOALS_SUCCESS,
} from "../../../constants/store";
import axiosInstance from "../../../config/https";

export const getGoalsAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });
    dispatch({
      type: GET_GOALS_IN_PROGRESS,
      payload: true,
    });

    const requestPayload = {
      action: "getGoals",
      data: localStorage.getItem("userToken"), //or get from auth redux state
    };

    const res = await axiosInstance.post(``, requestPayload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      if (res?.data.status == 200) {
        dispatch({
          type: GET_GOALS_SUCCESS,
          payload: res.data, //get goals payload
        });
      } else {
        dispatch({
          type: GET_GOALS_FAILED,
          payload: true,
        });
      }
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_FALSE,
    });
    if (e.response.status == 401) {
      dispatch({
        type: LOG_USER_OUT,
      });
    } else {
      dispatch({
        type: GET_GOALS_FAILED,
        payload: true,
      });
    }
  }
};

export const updateGoalsAction = (payload) => async (dispatch) => {
  dispatch({
    type: UPDATE_GOALS_IN_PROGRESS,
    payload: true,
  });
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });

    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: UPDATE_GOALS_SUCCESS,
        payload: res?.data.status, //send goal to be updated
      });
      setTimeout(() => {
        dispatch({
          type: UPDATE_GOALS_SUCCESS,
          payload: false, //send goal to be updated
        });
      }, 3000);
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_FALSE,
    });
    dispatch({
      type: UPDATE_GOALS_FAILED,
      payload: true,
    });
  }
};

export const archiveGoalsAction = (payload) => async (dispatch) => {
  dispatch({
    type: ARCHIVE_GOALS_IN_PROGRESS,
    payload: true,
  });
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });

    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: ARCHIVE_GOALS_SUCCESS,
        payload: res?.data.status,
      });
      setTimeout(() => {
        dispatch({
          type: ARCHIVE_GOALS_SUCCESS,
          payload: false, //send goal to be updated
        });
      }, 3000);
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_FALSE,
    });
    dispatch({
      type: ARCHIVE_GOALS_FAILED,
      payload: true,
    });
  }
};

export const refreshGoalsAction = () => async (dispatch) => {
  dispatch({
    type: REFRESH_GOALS,
  });
};

export const addNewGoalAction = (payload) => async (dispatch) => {
  dispatch({
    type: NEW_GOALS_IN_PROGRESS,
    payload: true,
  });
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });

    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: NEW_GOALS_SUCCESS,
        payload: res?.data,
      });
      setTimeout(() => {
        dispatch({
          type: NEW_GOALS_SUCCESS,
          payload: false, //send goal to be updated
        });
      }, 3000);
    }
  } catch (e) {
    dispatch({
      type: SET_LOADING_FALSE,
    });
    dispatch({
      type: NEW_GOALS_FAILED,
      payload: true,
    });
  }
};

export const getHelpAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SET_LOADING_TRUE,
    });

    const res = await axiosInstance.post(``, payload);
    if (res?.data) {
      dispatch({
        type: SET_LOADING_FALSE,
      });
      dispatch({
        type: NEW_GOALS_SUCCESS,
        payload: res?.data,
      });
      setTimeout(() => {
        dispatch({
          type: NEW_GOALS_SUCCESS,
          payload: false, //send goal to be updated
        });
      }, 3000);
      return res
    }
  } catch (e) {
    
  }
}